'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'output', 'edit',
    function ($scope, $modalInstance, output, edit) {

        $scope.ok = ok;
        $scope.cancel = cancel;

        init();

        // region Function

        function init() {
            $scope.output = angular.copy(output);
            $scope.edit = edit;
        }

        function ok() {
            $modalInstance.close($scope.output);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        // endregion

    }];